import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const FeatureCards = ({ onGetStarted }) => {
  const { t } = useTranslation();
  
  return (
    <section className="features-section">
      <div className="container">
        <div className="cta-section animate-fadeInUp">
          <div className="cta-content">
            <h3>{t('readyToTransform')}</h3>
            <p>{t('joinToday')}</p>
            <button 
              className="btn btn-primary cta-button"
              onClick={onGetStarted}
            >
              {t('getStarted')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;